import React from 'react';
import ProductImage from '@prisjakt/ui-product-image';

import * as S from './styles';

import { AdvizedToplist } from '../../types';

const Toplist = ({
  title,
  products,
  date,
  expert,
  category,
}: AdvizedToplist) => {
  return (
    <>
      <S.Title>{title}</S.Title>
      <S.Subtitle>
        {expert.name} listar {products.length} {category.name.toLowerCase()}
      </S.Subtitle>
      <S.Products>
        {products.slice(0, 3).map(product => (
          <S.Row key={product.name}>
            <S.Image>
              {product.image && (
                <ProductImage
                  name={product.name}
                  src={product.image}
                  fallback="https://cdn.pji.nu/product/standard/280/0.jpg"
                />
              )}
            </S.Image>
            <S.ProductName>{product.name}</S.ProductName>
          </S.Row>
        ))}
      </S.Products>
    </>
  );
};

export default Toplist;
